
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as startdhoCai5YvD_45D8uJHrmIJjuxD1i92PppkQc7SJZByEosMeta } from "/app/apps/frontend/pages/start.vue?macro=true";
import { default as preturiwDWbY9wUrB0J3Tg1wq_45K1tu_45QZVVbkVb6BB4udhwzLgMeta } from "/app/apps/frontend/pages/preturi.vue?macro=true";
import { default as termenioB0d1PyCbLUBoNGQZ4ZcwMC7jhPEq6RT9si2ia4xNo0Meta } from "/app/apps/frontend/pages/termeni.vue?macro=true";
import { default as cosk2cU0i0Wy2cCJIG3bE6MxUz58MxJKPIwExt8E0JlMkgMeta } from "/app/apps/frontend/pages/[[shop]]/cos.vue?macro=true";
import { default as logs2Kv1Fwk4getjGmcXWMmNph_45_45GEOE9bA0xF4_AQrcitkMeta } from "/app/apps/frontend/pages/platform/logs.vue?macro=true";
import { default as indexAoqILLaS0_qkKDca9lysaNpHdcGP1tD7GYi4T7ibOK8Meta } from "/app/apps/frontend/pages/[[shop]]/index.vue?macro=true";
import { default as indexzlVSzcLJuhaX7b1Pl_nCw6xTPX25yrBLomCTu3X432AMeta } from "/app/apps/frontend/pages/platform/index.vue?macro=true";
import { default as loginugHe8Q2DzxtxM4j1_MtXzZCBcRVH3YxJGi_klsAWla8Meta } from "/app/apps/frontend/pages/platform/login.vue?macro=true";
import { default as platiNvru3mx1RdBdTLh7ABkQSQM99R5WKC2CLMYmpbuwbBoMeta } from "/app/apps/frontend/pages/platform/plati.vue?macro=true";
import { default as cautaref_1lZrZ3KujvN1diCo7AhpEFUHiG3Yty3eUjIA2JBnMMeta } from "/app/apps/frontend/pages/[[shop]]/cautare.vue?macro=true";
import { default as comparaLdQb6BkHqRqaVkq3BDNNzzJzOCwXev2KY3QK4R3SdQcMeta } from "/app/apps/frontend/pages/[[shop]]/compara.vue?macro=true";
import { default as contactFvOik5eOBiMqFeWnT4z6k6sFJQsmqFJky5Wz8eW3exsMeta } from "/app/apps/frontend/pages/[[shop]]/contact.vue?macro=true";
import { default as confidentialitateuqj_45IBiMeT6dH41GVd_45bbbsXw_8q8prPOitVEMuHS_IMeta } from "/app/apps/frontend/pages/confidentialitate.vue?macro=true";
import { default as incasariSgrPOIv1JHbl2DUeGXtO3HBANnbs9y0BTwF_7qsgU94Meta } from "/app/apps/frontend/pages/platform/incasari.vue?macro=true";
import { default as _91slug_93R0nIW6voQEZVqdyb2UYii48gF6tEXHDJHiY_jE2PWGYMeta } from "/app/apps/frontend/pages/[[shop]]/cms/[slug].vue?macro=true";
import { default as indexwMDlSzrGHf6VEMS5M5G07uZ1B5xJ2SYlRSV4ud4al7wMeta } from "/app/apps/frontend/pages/[[shop]]/cont/index.vue?macro=true";
import { default as login3j14TzQSK3QoW9mKmeKIIJchoWXLCbUhOzXwheGib3MMeta } from "/app/apps/frontend/pages/[[shop]]/cont/login.vue?macro=true";
import { default as _91id_93t3KkGXNvqacsjaI3mtS80LfLZaq37UeeUIViwEiKiG0Meta } from "/app/apps/frontend/pages/platform/shops/[id].vue?macro=true";
import { default as indexLzsgL_ks0fGZfrEo0sUEZF4bIpzRQHSb1Rk0E7u0H8MMeta } from "/app/apps/frontend/pages/[[shop]]/admin/index.vue?macro=true";
import { default as indexYq5ak6gLihXrDqUoFV9IIlRQ3GtNd6sHniQjEZuTwQkMeta } from "/app/apps/frontend/pages/[[shop]]/admin/vinde/index.vue?macro=true";
import { default as indexzRKsncNrwtWi_45KxBnZlf9Ct1Lao2WDTJ6r6pJOw2TqMMeta } from "/app/apps/frontend/pages/[[shop]]/admin/vinde/reguli/index.vue?macro=true";
import { default as indexJ6orH6IvUw1waNa2jtBaQlptTn2xWZp5K_4ifrVMJ5EMeta } from "/app/apps/frontend/pages/[[shop]]/admin/vinde/preturi/index.vue?macro=true";
import { default as indexB_45LN9ie_aZdGqR_CIuEF8dysB7sueNwItNMwVbXcRZkMeta } from "/app/apps/frontend/pages/[[shop]]/admin/vinde/contract/index.vue?macro=true";
import { default as _91id_936j9h0Cgp4zmgGQjKbu0snbRYhU6UaJJegvgi_45pHpFfUMeta } from "/app/apps/frontend/pages/[[shop]]/admin/vinde/solicitari/[id].vue?macro=true";
import { default as indexnCcNwvOkprk_45feIEyn47ZsxM2Jhp3fxd8dDr50nCV7QMeta } from "/app/apps/frontend/pages/[[shop]]/admin/vinde/solicitari/index.vue?macro=true";
import { default as vindeYkq_45GtVX15VUc_R2soB07hrTpkPUjGvDcvKwkpDSIi4Meta } from "/app/apps/frontend/pages/[[shop]]/admin/vinde.vue?macro=true";
import { default as adreseGB_45xv52piKXlRTsmd5DX8EcBdZy888gvX3dodi0SBgoMeta } from "/app/apps/frontend/pages/[[shop]]/cont/adrese.vue?macro=true";
import { default as parola8riMbM4ZMzzjTBco0N6ywZX8Azf8LZZ0nnik1vI0WwAMeta } from "/app/apps/frontend/pages/[[shop]]/cont/parola.vue?macro=true";
import { default as profilxd3dAnhxb2TwVe_BmxWxTjOimr9J2Y0V00RtBSmLtqUMeta } from "/app/apps/frontend/pages/[[shop]]/cont/profil.vue?macro=true";
import { default as indexnE1uKf6ONG5d2Qm_45I5iD0aGEXEelzwSJsyXZRBtMmHwMeta } from "/app/apps/frontend/pages/[[shop]]/retur/index.vue?macro=true";
import { default as indexubX8aS0IeFoMjKcDLVVuBR00ko9vJfF1ifsJV_uRlnUMeta } from "/app/apps/frontend/pages/[[shop]]/vinde/index.vue?macro=true";
import { default as dezvoltator3Z3mpG1G_45TfBvBLiXMIYWWzn9JWcjPw7RELDm45LEDQMeta } from "/app/apps/frontend/pages/platform/dezvoltator.vue?macro=true";
import { default as indexGI74wRlu7NU0Pq1iRF1IBUrwHbs8_hyMPTc4p94LlU8Meta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/index.vue?macro=true";
import { default as siglewvqT_R4pdMY7XTkcVSANiV5Evobt9CPXgP1GGnh_63cMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/sigle.vue?macro=true";
import { default as aspect1kIN_A5_45eVssXY63t9X1yE6ufTGHw6FEuclIWM_458ERgMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/aspect.vue?macro=true";
import { default as importfU2o4ZJYDeEVCeXiQ1GILcDkyy6E_45NpQRVyF0Y3skDAMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/import.vue?macro=true";
import { default as contactDD9cBdegDmvrTx4f8t0pr3Q4mDDC8N88CY7Tj5poKisMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/contact.vue?macro=true";
import { default as magazin6LAugzM4Tv_45TVvFFlBAejcG_45U893o4rxXpOJLRDlOToMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/magazin.vue?macro=true";
import { default as homepageMGXw8gI_45i2a0xZlj8vQqSI9UptXB_45FbYz_45ekGOMpJzcMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/homepage.vue?macro=true";
import { default as experientaGawH0RSLBFqnjBBX7DrnXtvb2lxAGo4AuU3EoVJB8KMMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/experienta.vue?macro=true";
import { default as import_45xmlyZU5DlwPpJvVopSmKtwZEkt3wgS5oiePVLEx6eGHiiYMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/import-xml.vue?macro=true";
import { default as checkout_45tasksz29pFmfXarfUsz629goQDX63EQpA2hv9m6Ly3s6NxWkMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/checkout-tasks.vue?macro=true";
import { default as import_45giftsteraaLUGE_45CikKJfi0Hsru_45GyxnU4UY8YfwTL0r8Rk6iNYMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/import-giftster.vue?macro=true";
import { default as import_45novartshopfHrMrc7Jtsw4hFbWGjfQEs6AHkC4lfRF7MY46LL0Rq8Meta } from "/app/apps/frontend/pages/[[shop]]/admin/setari/import-novartshop.vue?macro=true";
import { default as setariMYomMUrDQ5Q12nzoDuBDl4iA3WjhyH56h3T5Hgcj8rwMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setari.vue?macro=true";
import { default as indexAWS7GFZmA7YVVtP_QHpm47OD9ts2QAXDqMaXF6VCgGMMeta } from "/app/apps/frontend/pages/[[shop]]/oferte/index.vue?macro=true";
import { default as passkeysRwQ7MM2w3law59K6TP8vkJA1XsafRkJd1uYJrb6EvrYMeta } from "/app/apps/frontend/pages/[[shop]]/cont/passkeys.vue?macro=true";
import { default as registerpfhPnwDHVeFuxA9NRHR5N33S6TYAgENAd06HvANUhjsMeta } from "/app/apps/frontend/pages/[[shop]]/cont/register.vue?macro=true";
import { default as wishlistG9aLSpmlXfb4S7JzlJg6YCtMvtCk0icgvUw2B27dnJQMeta } from "/app/apps/frontend/pages/[[shop]]/cont/wishlist.vue?macro=true";
import { default as indexpX5pFqUDV5_1LabUadpon8blA_45t2h_456jmnwT3zcrj6QMeta } from "/app/apps/frontend/pages/[[shop]]/produse/index.vue?macro=true";
import { default as indexkgj8_45UoSt2HSL_tGAXwS2M6NUromEfFG66E8B8B5vEgMeta } from "/app/apps/frontend/pages/[[shop]]/branduri/index.vue?macro=true";
import { default as indexeIX6U1qIJcPF2VzVhfqD6nflq_45dPLq4R7cg6noynSnEMeta } from "/app/apps/frontend/pages/[[shop]]/checkout/index.vue?macro=true";
import { default as _91slug_936_YkUk_45wSLS1EehLZpcnYucqhDgh4cbyRwNll8nToacMeta } from "/app/apps/frontend/pages/[[shop]]/produse/[slug].vue?macro=true";
import { default as indexdl4fyu0j_MeTztkCo8FoxhZfLPT39bYQvAnf0_yuwyMMeta } from "/app/apps/frontend/pages/[[shop]]/tracking/index.vue?macro=true";
import { default as send27DGjlGOXwfjaEpNhskN3SykqC3qPPOppiOiCoLqmDIMeta } from "/app/apps/frontend/pages/[[shop]]/admin/marketing/send.vue?macro=true";
import { default as indexS0naOFyJeoByt5kTPnMyGFwSoyk3bClF1SpXatwjkY4Meta } from "/app/apps/frontend/pages/[[shop]]/admin/marketing/index.vue?macro=true";
import { default as indexOxMmE9XHoWsnFr8l4rzxMSOquiKOi5dz3SJRoUf1UaIMeta } from "/app/apps/frontend/pages/[[shop]]/admin/marketing/history/index.vue?macro=true";
import { default as _91id_93qQt5aD5zd6ybjLQEJdu9GZm6MqSBSr5Go8uHq7x_PKIMeta } from "/app/apps/frontend/pages/[[shop]]/admin/marketing/templates/[id].vue?macro=true";
import { default as indexmRHQ2cVJwHYfjQ2m9I8DQeQC5Uq1eg03Ra_45ZnRTDcpEMeta } from "/app/apps/frontend/pages/[[shop]]/admin/marketing/campaigns/index.vue?macro=true";
import { default as index9S4gdE9pf5C1CWxMygHTd9s8rvwbgMbe4B9p5qNokCoMeta } from "/app/apps/frontend/pages/[[shop]]/admin/marketing/templates/index.vue?macro=true";
import { default as marketingHxCIzImtBxDBtwA7JUb18zruMiAeO23f7NoXKIVsrTUMeta } from "/app/apps/frontend/pages/[[shop]]/admin/marketing.vue?macro=true";
import { default as _91slug_93y7i7znxI3NlrThxOYwxGcjTI38SoN21_xMvjkpPIZ4sMeta } from "/app/apps/frontend/pages/[[shop]]/branduri/[slug].vue?macro=true";
import { default as indexKsn22ejhmyp3Zagid1zIE8pw_QDZLCNYGyQEOCcoxdEMeta } from "/app/apps/frontend/pages/[[shop]]/cataloage/index.vue?macro=true";
import { default as cancelaOsfY_4549XPLTosqpquqQSDpwKUj9OKG41uV1e7yulSgMeta } from "/app/apps/frontend/pages/[[shop]]/checkout/cancel.vue?macro=true";
import { default as _91id_93NZaqlCvEvVW9Mv7FxEwYoR6CMTVtqO64UEcsByat0LUMeta } from "/app/apps/frontend/pages/[[shop]]/cont/vinde/[id].vue?macro=true";
import { default as _91orderId_93Yc5B5FJ1LuCfna9_45p13BeQKvZTRAe_QX9ary03ii7P0Meta } from "/app/apps/frontend/pages/[[shop]]/retur/[orderId].vue?macro=true";
import { default as indexalZuNHkqkulV5L_456fTyq6UPl2jz90zQ3j2BtGa95hNUMeta } from "/app/apps/frontend/pages/[[shop]]/admin/help/index.vue?macro=true";
import { default as _91slug_93F4YHnsUqp4ISA9WH9eOBaZQ8R2gSWcW4ckvDIWuQUnQMeta } from "/app/apps/frontend/pages/[[shop]]/categorii/[slug].vue?macro=true";
import { default as successlEpKsv51HtfCerV6tgEjG_45FrCRaBgVMQa8uYtkXcT_458Meta } from "/app/apps/frontend/pages/[[shop]]/checkout/success.vue?macro=true";
import { default as indexGAMjiIMouT1GBiWtQWziH_FexNvzvNMHiDEbBi9qYVYMeta } from "/app/apps/frontend/pages/[[shop]]/cont/vinde/index.vue?macro=true";
import { default as _91slug_93nAENNyTd_45rE_45lNeYGtEQ7vcyAdmv7CSDfpbq1eVx27kMeta } from "/app/apps/frontend/pages/[[shop]]/generator/[slug].vue?macro=true";
import { default as indexRBhQYGqfxdt0ZE34Pk9KHWNsqOF5z9BiZKW7Ld2jAywMeta } from "/app/apps/frontend/pages/[[shop]]/resigilate/index.vue?macro=true";
import { default as noujnpsKLkYsfqYDyYUrNUrL2bcgyhqeF2wmN67fqghJz0Meta } from "/app/apps/frontend/pages/[[shop]]/admin/comenzi/nou.vue?macro=true";
import { default as _91id_93X3CIdv6qVsFDtjK96FK1lt30YNMQA6UsWeev_45Oubz78Meta } from "/app/apps/frontend/pages/[[shop]]/admin/pagini/[id].vue?macro=true";
import { default as indexQWiEeHNLo0Re3TL_45soDgeVsJ1PlgYmH_TBkCa409EZAMeta } from "/app/apps/frontend/pages/[[shop]]/admin/setup/index.vue?macro=true";
import { default as _91id_93Luq7AZsxwr0bSsP33x8mB1VbHav6wJgB8r5xpzY2PCAMeta } from "/app/apps/frontend/pages/[[shop]]/cont/comenzi/[id].vue?macro=true";
import { default as _91id_93gueFppVx_OhjXbipAKjqJ5SdMUXp6zQ6X_M_45gqJCascMeta } from "/app/apps/frontend/pages/[[shop]]/admin/comenzi/[id].vue?macro=true";
import { default as indexp24iLQ7oCTSKPY48hhXQ0LHTzcPBKxk2f4x7HFdQ7ZQMeta } from "/app/apps/frontend/pages/[[shop]]/admin/cupone/index.vue?macro=true";
import { default as indexqiKkeHzEZsy8rq9RlKaclDJEa6lsmzDoC0DDKaLBG_45EMeta } from "/app/apps/frontend/pages/[[shop]]/admin/oferte/index.vue?macro=true";
import { default as indexF8p0v6ItTUmM_453M_ILPKmiCHG7ijAwmpyRLe_45WAdTt0Meta } from "/app/apps/frontend/pages/[[shop]]/admin/pagini/index.vue?macro=true";
import { default as _91id_93OHDuu5k4QMXCf3oDoCbbJc30goiTFPyX1TS_455vubZ2cMeta } from "/app/apps/frontend/pages/[[shop]]/admin/produse/[id].vue?macro=true";
import { default as indexAY6bxTW7FPh2pAXNW50fKDeAF4L3sfYAUWzSzwUVRTcMeta } from "/app/apps/frontend/pages/[[shop]]/cont/comenzi/index.vue?macro=true";
import { default as indexe7u_45QMquZ3qplQjiZJwYEJpRXK_IC_45nIY078bgtj_CwMeta } from "/app/apps/frontend/pages/[[shop]]/admin/bannere/index.vue?macro=true";
import { default as indexLlfVGS0QcvOMq_4569mmGhOy0CuklxLcBQgxszMvgOHsAMeta } from "/app/apps/frontend/pages/[[shop]]/admin/comenzi/index.vue?macro=true";
import { default as indexo_zQAddfIU3H6JweHjWG2OrQS_GN_i_4546K7A3XGFpEUMeta } from "/app/apps/frontend/pages/[[shop]]/admin/familii/index.vue?macro=true";
import { default as indexlgHiVmsCaiPDI_ApYhAXou3MJEjZhb0o0GzzSOBEKXkMeta } from "/app/apps/frontend/pages/[[shop]]/admin/produse/index.vue?macro=true";
import { default as nou_45u3vjZmZx9CyGvsEhznffDOwt5Fyzf1z72XL6imNUyoMeta } from "/app/apps/frontend/pages/[[shop]]/admin/returnari/nou.vue?macro=true";
import { default as reset_45passwordWTbp0dqFY_XEJgeksC5TR7uc9dE8ipCunMwPDjVzgpQMeta } from "/app/apps/frontend/pages/[[shop]]/cont/reset-password.vue?macro=true";
import { default as indexOzjCiNumEGiXTa00CcYAfhnOIssUuPH76JbPdurR3RQMeta } from "/app/apps/frontend/pages/[[shop]]/admin/atribute/index.vue?macro=true";
import { default as indexyDVd_3Zd2fDdQT7WtOq7cr9uJNQ_bmLqXcVv4wArsLoMeta } from "/app/apps/frontend/pages/[[shop]]/admin/promotii/index.vue?macro=true";
import { default as index_eHsitMto9Ob62n17HrBhNRuwE8oluTx_sZVfFHiwsAMeta } from "/app/apps/frontend/pages/[[shop]]/admin/recenzii/index.vue?macro=true";
import { default as _91id_93XxV2Ps5lgF_45OdwBWUvYSsjg3GCZSTP3WrYC2G2xNKGAMeta } from "/app/apps/frontend/pages/[[shop]]/admin/returnari/[id].vue?macro=true";
import { default as indexKNw7UBRNdG7xVYi_45UUz799HNLKId1kLvsaZC4051KLcMeta } from "/app/apps/frontend/pages/[[shop]]/admin/vouchere/index.vue?macro=true";
import { default as forgot_45passwordUs8c9lbPi6gNOe7U_45_45QDBeYpQLfgKuUFHWzExMReFIEMeta } from "/app/apps/frontend/pages/[[shop]]/cont/forgot-password.vue?macro=true";
import { default as indexFy3TCxMF3tfN3TZvUXpnphM7YFaBOHXNOsopNldk0XwMeta } from "/app/apps/frontend/pages/[[shop]]/admin/abonament/index.vue?macro=true";
import { default as indexPQR7v2eyAdpa3nFyCYGBt4RdLTQA3uhkEQVmaR2wYBwMeta } from "/app/apps/frontend/pages/[[shop]]/admin/categorii/index.vue?macro=true";
import { default as indexRP0GuoZMJIVzm2AjuvWpM_45TukWAr_45FcazqpS0a1ozjgMeta } from "/app/apps/frontend/pages/[[shop]]/admin/integrari/index.vue?macro=true";
import { default as index0h7ZdLAHiDOFZ1qBMEdvieNt5Z3O1X9Lk1xKt0q7ZnEMeta } from "/app/apps/frontend/pages/[[shop]]/admin/intrebari/index.vue?macro=true";
import { default as indexIuY8k_SKmiObLhXj5bgjObrdW_RhLlyCShEOtt_OyGEMeta } from "/app/apps/frontend/pages/[[shop]]/admin/returnari/index.vue?macro=true";
import { default as index3aGygTcG4Fcqvh379rljNCTJ4om_45T9wrUjl79wH9piwMeta } from "/app/apps/frontend/pages/[[shop]]/admin/fidelitate/index.vue?macro=true";
import { default as _91id_93qvWix2E5BTCqI8zCG7b9jF22Dof8G4aA5pokH_453hxOsMeta } from "/app/apps/frontend/pages/[[shop]]/admin/generatoare/[id].vue?macro=true";
import { default as index9mJkFq8bO8YusfjHfHawtRWWG_45VilKQ4Hhi4IqYyzU4Meta } from "/app/apps/frontend/pages/[[shop]]/admin/resigilate/index.vue?macro=true";
import { default as _91orderNumber_93X4fr2atILpI4cYJ2fBltzjhdgdQT6DvWYC1BRWFfSAIMeta } from "/app/apps/frontend/pages/[[shop]]/tracking/[orderNumber].vue?macro=true";
import { default as indexj9dZIe95K1tFjlQjuVESsOIYVJ9xuGXvy4cbkNR_zbwMeta } from "/app/apps/frontend/pages/[[shop]]/admin/butoane-cta/index.vue?macro=true";
import { default as indexfzjkJN8k2R7PG5P8a8V7NJJ78cB9u2dHZQE0pLYU_70Meta } from "/app/apps/frontend/pages/[[shop]]/admin/catalog-pro/index.vue?macro=true";
import { default as indexplM33pA7IpWfbyLja_45ODtOrCXoDmmTRyD0t_n9arIEAMeta } from "/app/apps/frontend/pages/[[shop]]/admin/generatoare/index.vue?macro=true";
import { default as indexTOiTBd0ynXL_FLi93mlm5DYP2u_MP_45TPLUxGXjvTMU0Meta } from "/app/apps/frontend/pages/[[shop]]/admin/utilizatori/index.vue?macro=true";
import { default as index7SvvhS4DeQqBlgv_45osAmiBwhVeLntY8_45dkeLP4xY0YcMeta } from "/app/apps/frontend/pages/[[shop]]/admin/comenzi-rapide/index.vue?macro=true";
import { default as index0eQqIbaY9v_c4uj7mLn5XeT16GuZ167hG1Nw33viHLcMeta } from "/app/apps/frontend/pages/[[shop]]/admin/continut-produs/index.vue?macro=true";
import { default as indexoJPAHPBE97imgmbVLT3y1UITOi7CRLfX_BWXmAa2nxMMeta } from "/app/apps/frontend/pages/[[shop]]/admin/disponibilitate/index.vue?macro=true";
import { default as indexQHLP279NxH_45avNFFjWyAR3XGFM7AqsOCfVpzpo44UgUMeta } from "/app/apps/frontend/pages/[[shop]]/admin/reduceri-automate/index.vue?macro=true";
import { default as index9TJp7SgrhrdJz_45_56v_ReNncIpUKzkUGFUP97oJHmxwMeta } from "/app/apps/frontend/pages/[[shop]]/admin/preturi-cantitative/index.vue?macro=true";
import { default as indexSP66C9_tigRe8MtOAUVPl7nw5TDiWjd_W6udFY4b8i4Meta } from "/app/apps/frontend/pages/[[shop]]/admin/campuri-produse-complexe/index.vue?macro=true";
export default [
  {
    name: "start",
    path: "/start",
    meta: startdhoCai5YvD_45D8uJHrmIJjuxD1i92PppkQc7SJZByEosMeta || {},
    component: () => import("/app/apps/frontend/pages/start.vue")
  },
  {
    name: "preturi",
    path: "/preturi",
    meta: preturiwDWbY9wUrB0J3Tg1wq_45K1tu_45QZVVbkVb6BB4udhwzLgMeta || {},
    component: () => import("/app/apps/frontend/pages/preturi.vue")
  },
  {
    name: "termeni",
    path: "/termeni",
    meta: termenioB0d1PyCbLUBoNGQZ4ZcwMC7jhPEq6RT9si2ia4xNo0Meta || {},
    component: () => import("/app/apps/frontend/pages/termeni.vue")
  },
  {
    name: "shop-cos",
    path: "/:shop?/cos",
    component: () => import("/app/apps/frontend/pages/[[shop]]/cos.vue")
  },
  {
    name: "platform-logs",
    path: "/platform/logs",
    meta: { ...(logs2Kv1Fwk4getjGmcXWMmNph_45_45GEOE9bA0xF4_AQrcitkMeta || {}), ...{"middleware":["platform"]} },
    component: () => import("/app/apps/frontend/pages/platform/logs.vue")
  },
  {
    name: "shop",
    path: "/:shop?",
    component: () => import("/app/apps/frontend/pages/[[shop]]/index.vue")
  },
  {
    name: "platform",
    path: "/platform",
    meta: { ...(indexzlVSzcLJuhaX7b1Pl_nCw6xTPX25yrBLomCTu3X432AMeta || {}), ...{"middleware":["platform"]} },
    component: () => import("/app/apps/frontend/pages/platform/index.vue")
  },
  {
    name: "platform-login",
    path: "/platform/login",
    meta: loginugHe8Q2DzxtxM4j1_MtXzZCBcRVH3YxJGi_klsAWla8Meta || {},
    component: () => import("/app/apps/frontend/pages/platform/login.vue")
  },
  {
    name: "platform-plati",
    path: "/platform/plati",
    meta: { ...(platiNvru3mx1RdBdTLh7ABkQSQM99R5WKC2CLMYmpbuwbBoMeta || {}), ...{"middleware":["platform"]} },
    component: () => import("/app/apps/frontend/pages/platform/plati.vue")
  },
  {
    name: "shop-cautare",
    path: "/:shop?/cautare",
    component: () => import("/app/apps/frontend/pages/[[shop]]/cautare.vue")
  },
  {
    name: "shop-compara",
    path: "/:shop?/compara",
    component: () => import("/app/apps/frontend/pages/[[shop]]/compara.vue")
  },
  {
    name: "shop-contact",
    path: "/:shop?/contact",
    component: () => import("/app/apps/frontend/pages/[[shop]]/contact.vue")
  },
  {
    name: "confidentialitate",
    path: "/confidentialitate",
    meta: confidentialitateuqj_45IBiMeT6dH41GVd_45bbbsXw_8q8prPOitVEMuHS_IMeta || {},
    component: () => import("/app/apps/frontend/pages/confidentialitate.vue")
  },
  {
    name: "platform-incasari",
    path: "/platform/incasari",
    meta: { ...(incasariSgrPOIv1JHbl2DUeGXtO3HBANnbs9y0BTwF_7qsgU94Meta || {}), ...{"middleware":["platform"]} },
    component: () => import("/app/apps/frontend/pages/platform/incasari.vue")
  },
  {
    name: "shop-cms-slug",
    path: "/:shop?/cms/:slug()",
    component: () => import("/app/apps/frontend/pages/[[shop]]/cms/[slug].vue")
  },
  {
    name: "shop-cont",
    path: "/:shop?/cont",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/index.vue")
  },
  {
    name: "shop-cont-login",
    path: "/:shop?/cont/login",
    meta: login3j14TzQSK3QoW9mKmeKIIJchoWXLCbUhOzXwheGib3MMeta || {},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/login.vue")
  },
  {
    name: "platform-shops-id",
    path: "/platform/shops/:id()",
    meta: { ...(_91id_93t3KkGXNvqacsjaI3mtS80LfLZaq37UeeUIViwEiKiG0Meta || {}), ...{"middleware":["platform"]} },
    component: () => import("/app/apps/frontend/pages/platform/shops/[id].vue")
  },
  {
    name: "shop-admin",
    path: "/:shop?/admin",
    meta: { ...(indexLzsgL_ks0fGZfrEo0sUEZF4bIpzRQHSb1Rk0E7u0H8MMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/index.vue")
  },
  {
    name: vindeYkq_45GtVX15VUc_R2soB07hrTpkPUjGvDcvKwkpDSIi4Meta?.name,
    path: "/:shop?/admin/vinde",
    meta: { ...(vindeYkq_45GtVX15VUc_R2soB07hrTpkPUjGvDcvKwkpDSIi4Meta || {}), ...{"middleware":["auth","admin","sell"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/vinde.vue"),
    children: [
  {
    name: "shop-admin-vinde",
    path: "",
    meta: { ...(indexYq5ak6gLihXrDqUoFV9IIlRQ3GtNd6sHniQjEZuTwQkMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/vinde/index.vue")
  },
  {
    name: "shop-admin-vinde-reguli",
    path: "reguli",
    meta: { ...(indexzRKsncNrwtWi_45KxBnZlf9Ct1Lao2WDTJ6r6pJOw2TqMMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/vinde/reguli/index.vue")
  },
  {
    name: "shop-admin-vinde-preturi",
    path: "preturi",
    meta: { ...(indexJ6orH6IvUw1waNa2jtBaQlptTn2xWZp5K_4ifrVMJ5EMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/vinde/preturi/index.vue")
  },
  {
    name: "shop-admin-vinde-contract",
    path: "contract",
    meta: { ...(indexB_45LN9ie_aZdGqR_CIuEF8dysB7sueNwItNMwVbXcRZkMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/vinde/contract/index.vue")
  },
  {
    name: "shop-admin-vinde-solicitari-id",
    path: "solicitari/:id()",
    meta: { ...(_91id_936j9h0Cgp4zmgGQjKbu0snbRYhU6UaJJegvgi_45pHpFfUMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/vinde/solicitari/[id].vue")
  },
  {
    name: "shop-admin-vinde-solicitari",
    path: "solicitari",
    meta: { ...(indexnCcNwvOkprk_45feIEyn47ZsxM2Jhp3fxd8dDr50nCV7QMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/vinde/solicitari/index.vue")
  }
]
  },
  {
    name: "shop-cont-adrese",
    path: "/:shop?/cont/adrese",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/adrese.vue")
  },
  {
    name: "shop-cont-parola",
    path: "/:shop?/cont/parola",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/parola.vue")
  },
  {
    name: "shop-cont-profil",
    path: "/:shop?/cont/profil",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/profil.vue")
  },
  {
    name: "shop-retur",
    path: "/:shop?/retur",
    meta: {"middleware":"returns"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/retur/index.vue")
  },
  {
    name: "shop-vinde",
    path: "/:shop?/vinde",
    meta: {"middleware":"sell"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/vinde/index.vue")
  },
  {
    name: "platform-dezvoltator",
    path: "/platform/dezvoltator",
    meta: { ...(dezvoltator3Z3mpG1G_45TfBvBLiXMIYWWzn9JWcjPw7RELDm45LEDQMeta || {}), ...{"middleware":["platform"]} },
    component: () => import("/app/apps/frontend/pages/platform/dezvoltator.vue")
  },
  {
    name: setariMYomMUrDQ5Q12nzoDuBDl4iA3WjhyH56h3T5Hgcj8rwMeta?.name,
    path: "/:shop?/admin/setari",
    meta: { ...(setariMYomMUrDQ5Q12nzoDuBDl4iA3WjhyH56h3T5Hgcj8rwMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari.vue"),
    children: [
  {
    name: "shop-admin-setari",
    path: "",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/index.vue")
  },
  {
    name: "shop-admin-setari-sigle",
    path: "sigle",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/sigle.vue")
  },
  {
    name: "shop-admin-setari-aspect",
    path: "aspect",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/aspect.vue")
  },
  {
    name: "shop-admin-setari-import",
    path: "import",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/import.vue")
  },
  {
    name: "shop-admin-setari-contact",
    path: "contact",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/contact.vue")
  },
  {
    name: "shop-admin-setari-magazin",
    path: "magazin",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/magazin.vue")
  },
  {
    name: "shop-admin-setari-homepage",
    path: "homepage",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/homepage.vue")
  },
  {
    name: "shop-admin-setari-experienta",
    path: "experienta",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/experienta.vue")
  },
  {
    name: "shop-admin-setari-import-xml",
    path: "import-xml",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/import-xml.vue")
  },
  {
    name: "shop-admin-setari-checkout-tasks",
    path: "checkout-tasks",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/checkout-tasks.vue")
  },
  {
    name: "shop-admin-setari-import-giftster",
    path: "import-giftster",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/import-giftster.vue")
  },
  {
    name: "shop-admin-setari-import-novartshop",
    path: "import-novartshop",
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setari/import-novartshop.vue")
  }
]
  },
  {
    name: "shop-oferte",
    path: "/:shop?/oferte",
    meta: {"middleware":["offers"]},
    component: () => import("/app/apps/frontend/pages/[[shop]]/oferte/index.vue")
  },
  {
    name: "shop-cont-passkeys",
    path: "/:shop?/cont/passkeys",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/passkeys.vue")
  },
  {
    name: "shop-cont-register",
    path: "/:shop?/cont/register",
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/register.vue")
  },
  {
    name: "shop-cont-wishlist",
    path: "/:shop?/cont/wishlist",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/wishlist.vue")
  },
  {
    name: "shop-produse",
    path: "/:shop?/produse",
    component: () => import("/app/apps/frontend/pages/[[shop]]/produse/index.vue")
  },
  {
    name: "shop-branduri",
    path: "/:shop?/branduri",
    meta: {"middleware":["catalog-pro"]},
    component: () => import("/app/apps/frontend/pages/[[shop]]/branduri/index.vue")
  },
  {
    name: "shop-checkout",
    path: "/:shop?/checkout",
    component: () => import("/app/apps/frontend/pages/[[shop]]/checkout/index.vue")
  },
  {
    name: "shop-produse-slug",
    path: "/:shop?/produse/:slug()",
    component: () => import("/app/apps/frontend/pages/[[shop]]/produse/[slug].vue")
  },
  {
    name: "shop-tracking",
    path: "/:shop?/tracking",
    component: () => import("/app/apps/frontend/pages/[[shop]]/tracking/index.vue")
  },
  {
    name: marketingHxCIzImtBxDBtwA7JUb18zruMiAeO23f7NoXKIVsrTUMeta?.name,
    path: "/:shop?/admin/marketing",
    meta: { ...(marketingHxCIzImtBxDBtwA7JUb18zruMiAeO23f7NoXKIVsrTUMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/marketing.vue"),
    children: [
  {
    name: "shop-admin-marketing-send",
    path: "send",
    meta: { ...(send27DGjlGOXwfjaEpNhskN3SykqC3qPPOppiOiCoLqmDIMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/marketing/send.vue")
  },
  {
    name: "shop-admin-marketing",
    path: "",
    meta: { ...(indexS0naOFyJeoByt5kTPnMyGFwSoyk3bClF1SpXatwjkY4Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/marketing/index.vue")
  },
  {
    name: "shop-admin-marketing-history",
    path: "history",
    meta: { ...(indexOxMmE9XHoWsnFr8l4rzxMSOquiKOi5dz3SJRoUf1UaIMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/marketing/history/index.vue")
  },
  {
    name: "shop-admin-marketing-templates-id",
    path: "templates/:id()",
    meta: { ...(_91id_93qQt5aD5zd6ybjLQEJdu9GZm6MqSBSr5Go8uHq7x_PKIMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/marketing/templates/[id].vue")
  },
  {
    name: "shop-admin-marketing-campaigns",
    path: "campaigns",
    meta: { ...(indexmRHQ2cVJwHYfjQ2m9I8DQeQC5Uq1eg03Ra_45ZnRTDcpEMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/marketing/campaigns/index.vue")
  },
  {
    name: "shop-admin-marketing-templates",
    path: "templates",
    meta: { ...(index9S4gdE9pf5C1CWxMygHTd9s8rvwbgMbe4B9p5qNokCoMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/marketing/templates/index.vue")
  }
]
  },
  {
    name: "shop-branduri-slug",
    path: "/:shop?/branduri/:slug()",
    component: () => import("/app/apps/frontend/pages/[[shop]]/branduri/[slug].vue")
  },
  {
    name: "shop-cataloage",
    path: "/:shop?/cataloage",
    meta: {"middleware":["catalog-pro"]},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cataloage/index.vue")
  },
  {
    name: "shop-checkout-cancel",
    path: "/:shop?/checkout/cancel",
    component: () => import("/app/apps/frontend/pages/[[shop]]/checkout/cancel.vue")
  },
  {
    name: "shop-cont-vinde-id",
    path: "/:shop?/cont/vinde/:id()",
    meta: {"middleware":["auth","sell"]},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/vinde/[id].vue")
  },
  {
    name: "shop-retur-orderId",
    path: "/:shop?/retur/:orderId()",
    meta: {"middleware":"returns"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/retur/[orderId].vue")
  },
  {
    name: "shop-admin-help",
    path: "/:shop?/admin/help",
    meta: { ...(indexalZuNHkqkulV5L_456fTyq6UPl2jz90zQ3j2BtGa95hNUMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/help/index.vue")
  },
  {
    name: "shop-categorii-slug",
    path: "/:shop?/categorii/:slug()",
    component: () => import("/app/apps/frontend/pages/[[shop]]/categorii/[slug].vue")
  },
  {
    name: "shop-checkout-success",
    path: "/:shop?/checkout/success",
    component: () => import("/app/apps/frontend/pages/[[shop]]/checkout/success.vue")
  },
  {
    name: "shop-cont-vinde",
    path: "/:shop?/cont/vinde",
    meta: {"middleware":["auth","sell"]},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/vinde/index.vue")
  },
  {
    name: "shop-generator-slug",
    path: "/:shop?/generator/:slug()",
    meta: {"middleware":"generators"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/generator/[slug].vue")
  },
  {
    name: "shop-resigilate",
    path: "/:shop?/resigilate",
    meta: {"middleware":["refurbished"]},
    component: () => import("/app/apps/frontend/pages/[[shop]]/resigilate/index.vue")
  },
  {
    name: "shop-admin-comenzi-nou",
    path: "/:shop?/admin/comenzi/nou",
    meta: { ...(noujnpsKLkYsfqYDyYUrNUrL2bcgyhqeF2wmN67fqghJz0Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/comenzi/nou.vue")
  },
  {
    name: "shop-admin-pagini-id",
    path: "/:shop?/admin/pagini/:id()",
    meta: { ...(_91id_93X3CIdv6qVsFDtjK96FK1lt30YNMQA6UsWeev_45Oubz78Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/pagini/[id].vue")
  },
  {
    name: "shop-admin-setup",
    path: "/:shop?/admin/setup",
    meta: { ...(indexQWiEeHNLo0Re3TL_45soDgeVsJ1PlgYmH_TBkCa409EZAMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/setup/index.vue")
  },
  {
    name: "shop-cont-comenzi-id",
    path: "/:shop?/cont/comenzi/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/comenzi/[id].vue")
  },
  {
    name: "shop-admin-comenzi-id",
    path: "/:shop?/admin/comenzi/:id()",
    meta: { ...(_91id_93gueFppVx_OhjXbipAKjqJ5SdMUXp6zQ6X_M_45gqJCascMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/comenzi/[id].vue")
  },
  {
    name: "shop-admin-cupone",
    path: "/:shop?/admin/cupone",
    meta: { ...(indexp24iLQ7oCTSKPY48hhXQ0LHTzcPBKxk2f4x7HFdQ7ZQMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/cupone/index.vue")
  },
  {
    name: "shop-admin-oferte",
    path: "/:shop?/admin/oferte",
    meta: { ...(indexqiKkeHzEZsy8rq9RlKaclDJEa6lsmzDoC0DDKaLBG_45EMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/oferte/index.vue")
  },
  {
    name: "shop-admin-pagini",
    path: "/:shop?/admin/pagini",
    meta: { ...(indexF8p0v6ItTUmM_453M_ILPKmiCHG7ijAwmpyRLe_45WAdTt0Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/pagini/index.vue")
  },
  {
    name: "shop-admin-produse-id",
    path: "/:shop?/admin/produse/:id()",
    meta: { ...(_91id_93OHDuu5k4QMXCf3oDoCbbJc30goiTFPyX1TS_455vubZ2cMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/produse/[id].vue")
  },
  {
    name: "shop-cont-comenzi",
    path: "/:shop?/cont/comenzi",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/comenzi/index.vue")
  },
  {
    name: "shop-admin-bannere",
    path: "/:shop?/admin/bannere",
    meta: { ...(indexe7u_45QMquZ3qplQjiZJwYEJpRXK_IC_45nIY078bgtj_CwMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/bannere/index.vue")
  },
  {
    name: "shop-admin-comenzi",
    path: "/:shop?/admin/comenzi",
    meta: { ...(indexLlfVGS0QcvOMq_4569mmGhOy0CuklxLcBQgxszMvgOHsAMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/comenzi/index.vue")
  },
  {
    name: "shop-admin-familii",
    path: "/:shop?/admin/familii",
    meta: { ...(indexo_zQAddfIU3H6JweHjWG2OrQS_GN_i_4546K7A3XGFpEUMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/familii/index.vue")
  },
  {
    name: "shop-admin-produse",
    path: "/:shop?/admin/produse",
    meta: { ...(indexlgHiVmsCaiPDI_ApYhAXou3MJEjZhb0o0GzzSOBEKXkMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/produse/index.vue")
  },
  {
    name: "shop-admin-returnari-nou",
    path: "/:shop?/admin/returnari/nou",
    meta: { ...(nou_45u3vjZmZx9CyGvsEhznffDOwt5Fyzf1z72XL6imNUyoMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/returnari/nou.vue")
  },
  {
    name: "shop-cont-reset-password",
    path: "/:shop?/cont/reset-password",
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/reset-password.vue")
  },
  {
    name: "shop-admin-atribute",
    path: "/:shop?/admin/atribute",
    meta: { ...(indexOzjCiNumEGiXTa00CcYAfhnOIssUuPH76JbPdurR3RQMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/atribute/index.vue")
  },
  {
    name: "shop-admin-promotii",
    path: "/:shop?/admin/promotii",
    meta: { ...(indexyDVd_3Zd2fDdQT7WtOq7cr9uJNQ_bmLqXcVv4wArsLoMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/promotii/index.vue")
  },
  {
    name: "shop-admin-recenzii",
    path: "/:shop?/admin/recenzii",
    meta: { ...(index_eHsitMto9Ob62n17HrBhNRuwE8oluTx_sZVfFHiwsAMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/recenzii/index.vue")
  },
  {
    name: "shop-admin-returnari-id",
    path: "/:shop?/admin/returnari/:id()",
    meta: { ...(_91id_93XxV2Ps5lgF_45OdwBWUvYSsjg3GCZSTP3WrYC2G2xNKGAMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/returnari/[id].vue")
  },
  {
    name: "shop-admin-vouchere",
    path: "/:shop?/admin/vouchere",
    meta: { ...(indexKNw7UBRNdG7xVYi_45UUz799HNLKId1kLvsaZC4051KLcMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/vouchere/index.vue")
  },
  {
    name: "shop-cont-forgot-password",
    path: "/:shop?/cont/forgot-password",
    component: () => import("/app/apps/frontend/pages/[[shop]]/cont/forgot-password.vue")
  },
  {
    name: "shop-admin-abonament",
    path: "/:shop?/admin/abonament",
    meta: { ...(indexFy3TCxMF3tfN3TZvUXpnphM7YFaBOHXNOsopNldk0XwMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/abonament/index.vue")
  },
  {
    name: "shop-admin-categorii",
    path: "/:shop?/admin/categorii",
    meta: { ...(indexPQR7v2eyAdpa3nFyCYGBt4RdLTQA3uhkEQVmaR2wYBwMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/categorii/index.vue")
  },
  {
    name: "shop-admin-integrari",
    path: "/:shop?/admin/integrari",
    meta: { ...(indexRP0GuoZMJIVzm2AjuvWpM_45TukWAr_45FcazqpS0a1ozjgMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/integrari/index.vue")
  },
  {
    name: "shop-admin-intrebari",
    path: "/:shop?/admin/intrebari",
    meta: { ...(index0h7ZdLAHiDOFZ1qBMEdvieNt5Z3O1X9Lk1xKt0q7ZnEMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/intrebari/index.vue")
  },
  {
    name: "shop-admin-returnari",
    path: "/:shop?/admin/returnari",
    meta: { ...(indexIuY8k_SKmiObLhXj5bgjObrdW_RhLlyCShEOtt_OyGEMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/returnari/index.vue")
  },
  {
    name: "shop-admin-fidelitate",
    path: "/:shop?/admin/fidelitate",
    meta: { ...(index3aGygTcG4Fcqvh379rljNCTJ4om_45T9wrUjl79wH9piwMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/fidelitate/index.vue")
  },
  {
    name: "shop-admin-generatoare-id",
    path: "/:shop?/admin/generatoare/:id()",
    meta: { ...(_91id_93qvWix2E5BTCqI8zCG7b9jF22Dof8G4aA5pokH_453hxOsMeta || {}), ...{"middleware":["auth","admin","generators"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/generatoare/[id].vue")
  },
  {
    name: "shop-admin-resigilate",
    path: "/:shop?/admin/resigilate",
    meta: { ...(index9mJkFq8bO8YusfjHfHawtRWWG_45VilKQ4Hhi4IqYyzU4Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/resigilate/index.vue")
  },
  {
    name: "shop-tracking-orderNumber",
    path: "/:shop?/tracking/:orderNumber()",
    component: () => import("/app/apps/frontend/pages/[[shop]]/tracking/[orderNumber].vue")
  },
  {
    name: "shop-admin-butoane-cta",
    path: "/:shop?/admin/butoane-cta",
    meta: { ...(indexj9dZIe95K1tFjlQjuVESsOIYVJ9xuGXvy4cbkNR_zbwMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/butoane-cta/index.vue")
  },
  {
    name: "shop-admin-catalog-pro",
    path: "/:shop?/admin/catalog-pro",
    meta: { ...(indexfzjkJN8k2R7PG5P8a8V7NJJ78cB9u2dHZQE0pLYU_70Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/catalog-pro/index.vue")
  },
  {
    name: "shop-admin-generatoare",
    path: "/:shop?/admin/generatoare",
    meta: { ...(indexplM33pA7IpWfbyLja_45ODtOrCXoDmmTRyD0t_n9arIEAMeta || {}), ...{"middleware":["auth","admin","generators"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/generatoare/index.vue")
  },
  {
    name: "shop-admin-utilizatori",
    path: "/:shop?/admin/utilizatori",
    meta: { ...(indexTOiTBd0ynXL_FLi93mlm5DYP2u_MP_45TPLUxGXjvTMU0Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/utilizatori/index.vue")
  },
  {
    name: "shop-admin-comenzi-rapide",
    path: "/:shop?/admin/comenzi-rapide",
    meta: { ...(index7SvvhS4DeQqBlgv_45osAmiBwhVeLntY8_45dkeLP4xY0YcMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/comenzi-rapide/index.vue")
  },
  {
    name: "shop-admin-continut-produs",
    path: "/:shop?/admin/continut-produs",
    meta: { ...(index0eQqIbaY9v_c4uj7mLn5XeT16GuZ167hG1Nw33viHLcMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/continut-produs/index.vue")
  },
  {
    name: "shop-admin-disponibilitate",
    path: "/:shop?/admin/disponibilitate",
    meta: { ...(indexoJPAHPBE97imgmbVLT3y1UITOi7CRLfX_BWXmAa2nxMMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/disponibilitate/index.vue")
  },
  {
    name: "shop-admin-reduceri-automate",
    path: "/:shop?/admin/reduceri-automate",
    meta: { ...(indexQHLP279NxH_45avNFFjWyAR3XGFM7AqsOCfVpzpo44UgUMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/reduceri-automate/index.vue")
  },
  {
    name: "shop-admin-preturi-cantitative",
    path: "/:shop?/admin/preturi-cantitative",
    meta: { ...(index9TJp7SgrhrdJz_45_56v_ReNncIpUKzkUGFUP97oJHmxwMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/preturi-cantitative/index.vue")
  },
  {
    name: "shop-admin-campuri-produse-complexe",
    path: "/:shop?/admin/campuri-produse-complexe",
    meta: { ...(indexSP66C9_tigRe8MtOAUVPl7nw5TDiWjd_W6udFY4b8i4Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/app/apps/frontend/pages/[[shop]]/admin/campuri-produse-complexe/index.vue")
  }
]